(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initCard(card) {
    var productUrl = card.dataset.plUrl;
    var gallery = card.querySelector('[data-pl-gallery]');
    if (gallery) {
      var track = gallery.querySelector('[data-pl-track]');
      var slides = track ? track.querySelectorAll('.pl-gallery__slide') : [];
      var prev = gallery.querySelector('[data-pl-prev]');
      var next = gallery.querySelector('[data-pl-next]');
      var dots = gallery.querySelectorAll('[data-pl-dot]');
      var cur = 0;
      function goTo(idx) {
        cur = (idx + slides.length) % slides.length;
        track.style.transform = 'translateX(-' + (cur * 100) + '%)';
        dots.forEach(function(d, i) { d.classList.toggle('is-active', i === cur); });
      }
      if (slides.length > 1) {
        if (prev) prev.addEventListener('click', function(e){ e.preventDefault(); e.stopPropagation(); goTo(cur - 1); });
        if (next) next.addEventListener('click', function(e){ e.preventDefault(); e.stopPropagation(); goTo(cur + 1); });
        dots.forEach(function(dot){ dot.addEventListener('click', function(e){ e.preventDefault(); e.stopPropagation(); goTo(+dot.dataset.plDot); }); });
      }
    }
    if (productUrl) {
      card.style.cursor = 'pointer';
      card.addEventListener('click', function(e) { if (e.target.closest('button, a')) return; window.location.href = productUrl; });
    }
    var qBtn = card.querySelector('.pl-quickadd__btn:not(.pl-quickadd__btn--soldout)');
    if (!qBtn) return;
    qBtn.addEventListener('click', function(e) {
      e.preventDefault(); e.stopPropagation();
      var variantId = qBtn.dataset.variantId;
      if (!variantId) return;
      var originalHTML = qBtn.innerHTML;
      qBtn.disabled = true;
      qBtn.innerHTML = 'Adding…';
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: variantId, quantity: 1 }) })
        .then(function(res) { if (!res.ok) throw new Error(); return res.json(); })
        .then(function() {
          qBtn.innerHTML = '✓ Added!'; qBtn.style.background = '#1a7a4a';
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          document.dispatchEvent(new CustomEvent('theme:cart:open', { bubbles: true }));
          setTimeout(function() { qBtn.disabled = false; qBtn.style.background = ''; qBtn.innerHTML = originalHTML; }, 2200);
        })
        .catch(function() { qBtn.innerHTML = 'Error'; qBtn.style.background = '#c0392b'; setTimeout(function() { qBtn.disabled = false; qBtn.style.background = ''; qBtn.innerHTML = originalHTML; }, 2000); });
    });
  }
  function initAll() { document.querySelectorAll('[data-pl-card]').forEach(initCard); }
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', initAll) : initAll();
  document.addEventListener('shopify:section:load', initAll);
})();

  } catch(e) { console.error(e); }
})();
})();
